import { render, staticRenderFns } from "./otherDelivery.vue?vue&type=template&id=3e42a1db"
import script from "./otherDelivery.vue?vue&type=script&lang=js"
export * from "./otherDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports